import { render, staticRenderFns } from "./CheckList_action_taken.vue?vue&type=template&id=5524ee40&"
import script from "./CheckList_action_taken.vue?vue&type=script&lang=js&"
export * from "./CheckList_action_taken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports